"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var databus_1 = require("@portals/databus");
var constants_1 = require("../constants");
exports.selectedSupplierSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.SELECTED_SUPPLIER })
        ? databus_1.Databus.getData({ name: constants_1.SELECTED_SUPPLIER })
        : {};
};
exports.selectedSupplierIdSelector = function () {
    var supplier = databus_1.Databus.getData({ name: constants_1.SELECTED_SUPPLIER })
        ? databus_1.Databus.getData({ name: constants_1.SELECTED_SUPPLIER })
        : {};
    return supplier.id;
};
exports.allSuppliersSelector = function () {
    return databus_1.Databus.getData({ name: constants_1.ALL_SUPPLIERS })
        ? databus_1.Databus.getData({ name: constants_1.ALL_SUPPLIERS })
        : [];
};
exports.suppliersIdsSelector = function () {
    var suppliers = databus_1.Databus.getData({
        name: constants_1.ALL_SUPPLIERS,
    });
    if (suppliers && suppliers.length) {
        return suppliers.map(function (_a) {
            var id = _a.id;
            return id;
        });
    }
    return [];
};
exports.supplierCountryListSelector = function () {
    var countryList = databus_1.Databus.getData({ name: constants_1.SUPPLIER_COUNTRY_LIST })
        ? databus_1.Databus.getData({ name: constants_1.SUPPLIER_COUNTRY_LIST })
        : [];
    return countryList;
};
